import { ReactNode } from "react";
import { motion, useReducedMotion } from "framer-motion";
import { pageVariants } from "../theme/motion";

export default function PageTransition({ children }: { children: ReactNode }) {
  const reduce = useReducedMotion();
  if (reduce) return <>{children}</>;
  return (
    <motion.div variants={pageVariants} initial="initial" animate="animate" exit="exit">
      {children}
    </motion.div>
  );
}
